
import { BasicModel } from "@goodgamestudios/core";
import { BasicDialogHandler } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2AntiCheatEvent } from "../../../event/Poker2AntiCheatEvent";
import { Poker2OnTableEvent } from "../../../event/Poker2OnTableEvent";
import { TournamentResultVO } from "../../../gamevo/TournamentResultVO";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2TourResult1Dialog } from "../../../view/dialogs/tournament/Poker2TourResult1Dialog";
import { Poker2TourResult2Dialog } from "../../../view/dialogs/tournament/Poker2TourResult2Dialog";
import { Poker2TourResult3Dialog } from "../../../view/dialogs/tournament/Poker2TourResult3Dialog";
import { Poker2TourResultDialogProperties } from "../../../view/dialogs/tournament/Poker2TourResultDialogProperties";
import { Poker2LayoutManager } from "../../../view/Poker2LayoutManager";
import { Poker2Command } from "../Poker2Command";

export class JENCommand extends Poker2Command {
    protected get cmdId(): string {
        return "jen";
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var resultVO: TournamentResultVO = Poker2Model.tournamentData.parse_JEN(JSON.parse(params[1]));

            var dialogClassName: string;

            console.log("JENCommand, resultVO: " + resultVO.toString());

            if (resultVO.rank == 1) {
                // 1st rank
                dialogClassName = "Poker2TourResult1Dialog";
            }
            else if (resultVO.chips > 0) {
                // within best 10%
                dialogClassName = "Poker2TourResult2Dialog";
            }
            else {
                // not within best 10%
                dialogClassName = "Poker2TourResult3Dialog";
            }
            BasicDialogHandler.getInstance().registerDialogs(dialogClassName, new Poker2TourResultDialogProperties(resultVO, null), true, BasicDialogHandler.PRIORITY_TOP);

            // stand up player
            this.controller.dispatchEvent(new Poker2OnTableEvent("standUp", []));
            return true;
        }
        else
            return super.executeCommand(error, params);
    }

    private leaveToLobby(): void {
        if (this.layoutManager.currentState == 10) {
            BasicDialogHandler.getInstance().blockDialogs = false;
            BasicModel.smartfoxClient.sendMessage("tle", []);
            this.controller.dispatchEvent(new Poker2AntiCheatEvent("antiCheatRemoveConnection"));
        }
        this.layoutManager.state = 11;
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
